<h2 id="select-tmpl-format-title">{{ 'esploro.research.cv.page.format.title' | translate }}</h2>
<section class="margin-bottom-md">
  <em class="info-text">{{ 'esploro.research.cv.page.format.message.1' | translate }}</em>
</section>
<div [formGroup]="form" aria-labelledby="select-tmpl-format-title">
  @if (false) {
    <p class="margin-bottom-sm">
      <mat-form-field>
        <mat-label>{{ 'esploro.research.cv.page.format.fileFormat.select' | translate }}</mat-label>
        <mat-select formControlName="format">
          @for (format of ['docx', 'pdf', 'txt']; track format) {
            <mat-option [value]="format">
              {{ format }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </p>
  }
  <p class="margin-bottom-sm">
    <mat-form-field>
      <mat-label>{{ 'research.language.overline.default.default' | translate }}</mat-label>
      <mat-select formControlName="language">
        @for (lang of languages; track lang) {
          <mat-option [value]="lang.threeLetterCode">
            {{ lang.twoLetterCode | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </p>
</div>
